var _defs, _circle, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSarigatoLogoCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sygnet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.015,
    height: 50,
    viewBox: "0 0 53.015 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e61c64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea2046"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.149,
    y1: 0.421,
    x2: -0.124,
    y2: 0.421,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7f1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1.367,
    y1: 0.559,
    x2: 0.019,
    y2: 0.558,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#f7bb66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7f1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.498,
    y1: 0.298,
    x2: 1.291,
    y2: 0.726,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f7bb66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7f1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.788,
    y1: 0.307,
    x2: 1.521,
    y2: 0.307,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7f1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#f7bb66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff7b2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.14,
    y1: -0.406,
    x2: 0.739,
    y2: 1.014,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#f7bb66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7f1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.255,
    y1: -0.198,
    x2: 0.255,
    y2: 1.049,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f7bb66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7f1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1.114,
    y1: 0.325,
    x2: -0.032,
    y2: 0.325,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#f7bb66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7f1a"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(3.015)",
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M47.278,19.707l4.5,4.52-5.25-.009v8.63l-11.2,10.6,1.8,1.875-9.547,8.643V35.3l-4.374-4.05L12.43,22.708a24.5,24.5,0,0,1,4.625-6.445c.114-.114.224-.223.342-.333l8.051.4,9.939,10.3,8.32-6.805,3.576-.109Z",
    transform: "translate(-6.76 -8.664)",
    fill: "rgba(0,0,0,0.1)",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 5.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M16.856,17.54v14.1L.24,17.54Z",
    transform: "translate(-0.131 -14.908)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M78.2,22.535l4.5,4.52H69.29l5.473-4.525Z",
    transform: "translate(-37.685 -17.622)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M16.726,11.77l5.948,5.916L16.726,28.5,0,11.77Z",
    transform: "translate(0 -11.77)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M62.75,46.254v-16.8l8.456-6.915h3.439V34.358Z",
    transform: "translate(-34.128 -17.628)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M36.67,28.506V11.78L53.5,28.506,48.566,40.4Z",
    transform: "translate(-19.944 -11.775)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M55.211,66.986,45.66,76.537V57.43L59.4,59.282,53.455,65.23Z",
    transform: "translate(-24.834 -36.604)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M48.566,60.346l-11.9-11.9H60.461Z",
    transform: "translate(-19.944 -31.719)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-8)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M36.67,11.77V27.05l.36-14.92Z",
    transform: "translate(-19.944 -6.401)",
    fill: "#ffe199",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M36.71,48.42H60.474l-11.882.356Z",
    transform: "translate(-19.966 -26.335)",
    fill: "#ffe199",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M88.11,22.54l.328,3.763V22.54Z",
    transform: "translate(-47.921 -12.259)",
    fill: "#ffe199",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M45.66,57.43v.461l5.592,5.131Z",
    transform: "translate(-24.834 -31.235)",
    fill: "#ffe199",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M35.82,11.77h.388V27.05Z",
    transform: "translate(-19.482 -6.401)",
    fill: "#f09339",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M36.71,48.077l16.512-.287,7.252.287Z",
    transform: "translate(-19.966 -25.992)",
    fill: "#f09339",
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(2.039 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M16.534,28.811,5.77,17.54,19.846,31.62Z",
    transform: "translate(-5.177 -17.54)",
    fill: "#ffe199",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M4.47,17.54h.588L13.725,26.2Z",
    transform: "translate(-4.47 -17.54)",
    fill: "#f09339",
    fillRule: "evenodd"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M89.149,28.4H88.83V25.01Z",
    transform: "translate(-48.313 -13.602)",
    fill: "#f09339",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M67.311,41.963,63.019,37.21l-.269.223Z",
    transform: "translate(-34.128 -20.238)",
    fill: "#ffe199",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M55.922,67.145l-.274.274L49.71,61.48Z",
    transform: "translate(-27.036 -33.438)",
    fill: "#f09339",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSarigatoLogoCircle);
export default __webpack_public_path__ + "static/media/sarigato-logo-circle.5037df0d91a65debe137a2d5d00ed10e.svg";
export { ForwardRef as ReactComponent };